import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  StyledTrdInfo,
  StyledTrdInfoVdp,
  StyledTrdBox,
  TrdIcon
} from './Styles';
import iconMap from '../../_shared/constants/iconMap';
import { ReactTooltipStyled } from '../../_shared/components/BadgeWithTooltip/Styles';
import useUserList from '../../_shared/hooks/user/useUserList';

const propTypes = {
  displayType: PropTypes.oneOf(['list', 'vdp'])
};

const defaultProps = {
  displayType: 'list'
};

const TradeRevDirect = ({
  testId,
  shippingDetails,
  displayType,
  dealer,
  network,
  isValidTransportEstimate,
  isAtAdesa
}) => {
  const { data: usersList } = useUserList();
  if (
    network?.isDealerGroupNetwork ||
    dealer?.network?.isDealerGroupNetwork ||
    !dealer?.isTrdSeller ||
    (usersList && usersList?.[0]?.isTrdExemptBuyer) ||
    isAtAdesa
  ) {
    return null;
  }
  const variant = isValidTransportEstimate ? 'hasQuote' : 'noQuote';
  const trdIconLabel = (
    <>
      <TrdIcon src={iconMap[2]} data-for="trdShippingToolTip" data-tip />
      <FormattedMessage id="trd.description" />
    </>
  );
  return (
    <>
      {displayType === 'list' ? (
        <StyledTrdBox testId={`${testId}-trd`}>
          <StyledTrdInfo>{trdIconLabel}</StyledTrdInfo>
        </StyledTrdBox>
      ) : (
        <StyledTrdInfoVdp variant={variant}>{trdIconLabel}</StyledTrdInfoVdp>
      )}
      <ReactTooltipStyled
        id="trdShippingToolTip"
        arrowColor="transparent"
        effect="solid"
        place="bottom"
      >
        <FormattedMessage
          id={
            shippingDetails?.isShippingPromotion
              ? 'trd.tooltip.promo'
              : 'trd.tooltip'
          }
        />
      </ReactTooltipStyled>
    </>
  );
};

TradeRevDirect.propTypes = propTypes;
TradeRevDirect.defaultProps = defaultProps;

export default React.memo(TradeRevDirect);
